module.exports = __webpack_public_path__ + "img/prediction_generate_columns.f510d558.png";